export default "/images/vendor/flag-icons/flags/4x3/gs.svg?d1b8447c836a68c0518f6b33823efdb7";